export const contentDirectionMixin = {
    data() {
        return {
            rtlLanguages: ['ar', 'he', 'fa', 'ur', 'az', 'dv', 'ku'],
        };
    },
    methods: {
        isRtlLanguageFunc(lang, customStyle) {
            if (this.rtlLanguages.includes(lang)) {
                if (customStyle) {
                    return { ...customStyle };
                }
                return { direction: 'rtl' };
            }
        },
    },
};
